module.exports = __webpack_public_path__ + "img/p4-grid.b8fad29e.png";